import React, { Component } from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const DetailedCampaignTable: React.FC = () => {
  const campaigns = [{
    name: 'LED Headlamp Digital Launch',
    channel: 'Digital',
    type: 'Product Launch',
    spend: 45.2,
    impressions: 2850000,
    clicks: 142500,
    ctr: 5.0,
    leads: 1240,
    conversions: 185,
    roi: 342,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'TV Brand Awareness - Safety',
    channel: 'ATL',
    type: 'Brand',
    spend: 82.5,
    impressions: 8500000,
    clicks: 0,
    ctr: 0,
    leads: 920,
    conversions: 112,
    roi: 168,
    trend: 'stable',
    status: 'Active'
  }, {
    name: 'Trade Show - Auto Expo',
    channel: 'BTL',
    type: 'Event',
    spend: 52.4,
    impressions: 125000,
    clicks: 0,
    ctr: 0,
    leads: 1850,
    conversions: 178,
    roi: 185,
    trend: 'down',
    status: 'Completed'
  }, {
    name: 'Social Media - EV Components',
    channel: 'Digital',
    type: 'Awareness',
    spend: 32.8,
    impressions: 4200000,
    clicks: 210000,
    ctr: 5.0,
    leads: 1680,
    conversions: 198,
    roi: 285,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Print Media - Business Publications',
    channel: 'ATL',
    type: 'Brand',
    spend: 45.8,
    impressions: 1200000,
    clicks: 0,
    ctr: 0,
    leads: 485,
    conversions: 68,
    roi: 142,
    trend: 'stable',
    status: 'Active'
  }, {
    name: 'Direct Mail - Aftermarket Campaign',
    channel: 'BTL',
    type: 'Direct',
    spend: 22.8,
    impressions: 85000,
    clicks: 0,
    ctr: 0,
    leads: 890,
    conversions: 156,
    roi: 287,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Search Ads - Product Keywords',
    channel: 'Digital',
    type: 'Performance',
    spend: 35.7,
    impressions: 1850000,
    clicks: 92500,
    ctr: 5.0,
    leads: 1125,
    conversions: 168,
    roi: 318,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Dealer Network Events',
    channel: 'BTL',
    type: 'Event',
    spend: 38.6,
    impressions: 42000,
    clicks: 0,
    ctr: 0,
    leads: 650,
    conversions: 98,
    roi: 156,
    trend: 'down',
    status: 'Active'
  }, {
    name: 'Display Ads - Remarketing',
    channel: 'Digital',
    type: 'Performance',
    spend: 28.4,
    impressions: 3200000,
    clicks: 160000,
    ctr: 5.0,
    leads: 845,
    conversions: 125,
    roi: 245,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Radio Campaign - Metro Cities',
    channel: 'ATL',
    type: 'Awareness',
    spend: 28.3,
    impressions: 2400000,
    clicks: 0,
    ctr: 0,
    leads: 520,
    conversions: 72,
    roi: 138,
    trend: 'stable',
    status: 'Active'
  }];
  const getChannelColor = (channel: string) => {
    switch (channel) {
      case 'Digital':
        return 'bg-orange-100 text-orange-800';
      case 'ATL':
        return 'bg-blue-100 text-blue-800';
      case 'BTL':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'Product Launch':
        return 'bg-purple-100 text-purple-800';
      case 'Brand':
        return 'bg-blue-100 text-blue-800';
      case 'Event':
        return 'bg-green-100 text-green-800';
      case 'Awareness':
        return 'bg-yellow-100 text-yellow-800';
      case 'Performance':
        return 'bg-red-100 text-red-800';
      case 'Direct':
        return 'bg-indigo-100 text-indigo-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getStatusColor = (status: string) => {
    return status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600';
  };
  const getROIColor = (roi: number) => {
    if (roi >= 300) return 'text-green-600 font-bold';
    if (roi >= 200) return 'text-green-600';
    if (roi >= 150) return 'text-yellow-600';
    return 'text-gray-700';
  };
  return <Card className="p-6" data-id="element-7320">
      <div className="flex items-center justify-between mb-4" data-id="element-7321">
        <div data-id="element-7322">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-7323">
            Detailed Campaign Performance
          </h3>
          <p className="text-sm text-gray-600" data-id="element-7324">
            Complete metrics including Spend, CTR, Leads, and ROI
          </p>
        </div>
        <div className="text-sm text-gray-500" data-id="element-7325">
          {campaigns.filter(c => c.status === 'Active').length} Active
          Campaigns
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-7326">
        <table className="w-full" data-id="element-7327">
          <thead data-id="element-7328">
            <tr className="border-b-2 border-gray-300" data-id="element-7329">
              <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7330">
                Campaign Name
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7331">
                Channel
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7332">
                Type
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7333">
                Spend (₹L)
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7334">
                Impressions
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7335">
                CTR %
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7336">
                Leads
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7337">
                Conversions
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7338">
                ROI %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7339">
                Trend
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7340">
                Status
              </th>
            </tr>
          </thead>
          <tbody data-id="element-7341">
            {campaigns.map((campaign, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-7342">
                <td className="py-3 px-4 text-sm font-medium text-gray-800" data-id="element-7343">
                  {campaign.name}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7344">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getChannelColor(campaign.channel)}`} data-id="element-7345">
                    {campaign.channel}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7346">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getTypeColor(campaign.type)}`} data-id="element-7347">
                    {campaign.type}
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7348">
                  {campaign.spend}
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7349">
                  {campaign.impressions > 0 ? (campaign.impressions / 1000000).toFixed(2) + 'M' : '—'}
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7350">
                  {campaign.ctr > 0 ? campaign.ctr.toFixed(1) + '%' : '—'}
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7351">
                  {campaign.leads.toLocaleString()}
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-7352">
                  {campaign.conversions}
                </td>
                <td className={`py-3 px-4 text-sm text-right ${getROIColor(campaign.roi)}`} data-id="element-7353">
                  {campaign.roi}%
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7354">
                  {campaign.trend === 'up' && <TrendingUpIcon size={16} className="inline text-green-600" data-id="element-7355" />}
                  {campaign.trend === 'down' && <TrendingDownIcon size={16} className="inline text-red-600" data-id="element-7356" />}
                  {campaign.trend === 'stable' && <span className="text-gray-400" data-id="element-7357">—</span>}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7358">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(campaign.status)}`} data-id="element-7359">
                    {campaign.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7360">
        <div className="grid grid-cols-6 gap-4 text-sm" data-id="element-7361">
          <div className="text-center" data-id="element-7362">
            <div className="text-gray-600" data-id="element-7363">Total Spend</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-7364">
              ₹{campaigns.reduce((sum, c) => sum + c.spend, 0).toFixed(1)}L
            </div>
          </div>
          <div className="text-center" data-id="element-7365">
            <div className="text-gray-600" data-id="element-7366">Total Impressions</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-7367">
              {(campaigns.reduce((sum, c) => sum + c.impressions, 0) / 1000000).toFixed(1)}
              M
            </div>
          </div>
          <div className="text-center" data-id="element-7368">
            <div className="text-gray-600" data-id="element-7369">Avg CTR</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-7370">
              {(campaigns.reduce((sum, c) => sum + c.ctr, 0) / campaigns.filter(c => c.ctr > 0).length).toFixed(1)}
              %
            </div>
          </div>
          <div className="text-center" data-id="element-7371">
            <div className="text-gray-600" data-id="element-7372">Total Leads</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7373">
              {campaigns.reduce((sum, c) => sum + c.leads, 0).toLocaleString()}
            </div>
          </div>
          <div className="text-center" data-id="element-7374">
            <div className="text-gray-600" data-id="element-7375">Total Conversions</div>
            <div className="text-xl font-bold text-yellow-600" data-id="element-7376">
              {campaigns.reduce((sum, c) => sum + c.conversions, 0)}
            </div>
          </div>
          <div className="text-center" data-id="element-7377">
            <div className="text-gray-600" data-id="element-7378">Avg ROI</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7379">
              {(campaigns.reduce((sum, c) => sum + c.roi, 0) / campaigns.length).toFixed(0)}
              %
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default DetailedCampaignTable;